import {
  QuestionBase,
  QuestionControlOptions
} from '../question-types/question-base';

export interface CheckboxQuestionOptions
  extends QuestionControlOptions<boolean> {
  description?: string;
}
export class CheckboxQuestion extends QuestionBase<boolean>
  implements CheckboxQuestionOptions {
  controlType = 'checkbox';
  description?: string;

  constructor(options: CheckboxQuestionOptions) {
    super(options);
    this.value = this.value === true; // keep as true iff passed in as true
    this.description = options.description || '';
  }
}
